import { render, staticRenderFns } from "./_ModalRemessas.vue?vue&type=template&id=d723e7fa&scoped=true&"
import script from "./_ModalRemessas.vue?vue&type=script&lang=js&"
export * from "./_ModalRemessas.vue?vue&type=script&lang=js&"
import style0 from "./_ModalRemessas.vue?vue&type=style&index=0&id=d723e7fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d723e7fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDataTable,VIcon,VMain,VPagination,VRow})
